import Loader from "components/shared/loader";
import { dateTimeToView, humanizedTimeRange } from "helpers/date";
import { divIcon } from "leaflet";
import React from "react";
import { Marker, Tooltip } from "react-leaflet";
import { DefaultTemplate } from "../templates";
import BidRoute from "./bidRoute";
import MapContainer from "./container";

export default class ModalMap extends DefaultTemplate {
    componentDidMount() {
        if (!this.props.data.bidId) {
            this.setState({ isLoading: false });
        }
    }

    renderMapBody = () => {
        switch (this.props.data.dataType) {
            case "refueling":
                return this.refuelingInfo();
            default:
                return this.bidRoute();
        }
    };

    setLoading = (value) => {
        this.setState({ isLoading: value });
    };

    refuelingInfo = () => {
        const { bidId, coordinate, address, resource } = this.props.data;
        const iconOptions = resource?.iconUrl
            ? {
                  html: `<img src=${resource.iconUrl} class="route-icon__refueling-logo" />`,
                  className: "route-icon route-icon--refueling-wrap",
                  iconSize: [24, 24],
              }
            : { className: "route-icon route-icon--refueling" };
        const RefuleingLocation = () => (
            <Marker position={[coordinate.y, coordinate.x]} icon={divIcon(iconOptions)} zIndexOffset={1005}>
                <Tooltip direction="top">
                    <div>{address}</div>
                </Tooltip>
            </Marker>
        );

        return (
            <BidRoute
                bidId={bidId}
                setLoading={this.setLoading}
                IdleLocation={RefuleingLocation}
            />
        );
    };

    bidRoute = () => {
        const { bidId, coordinate, duration, startedAt, endedAt, location } = this.props.data;
        const IdleLocation = () => (
            <Marker
                position={[coordinate.y, coordinate.x]}
                icon={divIcon({ className: "route-icon route-icon--between", iconSize: [20, 20] })}
                zIndexOffset={1005}
            >
                <Tooltip className="map__tooltip--default" direction="top">
                    <div>
                        <strong>Место простоя:</strong>
                        <p className="text-wrap-initial">{location}</p>
                        <strong>Период простоя:</strong>
                        <div className="text-muted">
                            {dateTimeToView(startedAt)} - {dateTimeToView(endedAt)}
                            &nbsp;({humanizedTimeRange(duration)}) ({dateTimeToView(startedAt, "Z")})
                        </div>
                    </div>
                </Tooltip>
            </Marker>
        );
        return (
            <BidRoute
                bidId={bidId}
                setLoading={(val) => this.setState({ isLoading: val })}
                IdleLocation={IdleLocation}
            />
        );
    };

    renderBody = () => {
        const { coordinate } = this.props.data;
        return (
            <>
                {this.state.isLoading && (
                    <div className="loader-snippet--disable-loader">
                        <Loader />
                    </div>
                )}
                <MapContainer center={[coordinate.y, coordinate.x]} zoom={12}>
                    {this.renderMapBody()}
                </MapContainer>
            </>
        );
    };
}
